<template>
    <div class="edit-add-house">
        <alart-msg :display="alartError.state" styleType="error" @alartStatus="closeAlart()">
            <span class="title" slot="title">{{alartError.msg}}</span>
        </alart-msg>
        <alart-msg :display="alartSuccess.state" styleType="success" @alartStatus="closeAlart()">
            <span class="title" slot="title">{{alartSuccess.msg}}</span>
        </alart-msg>
        <add-equips @setEquips="setNewEquips($event)"></add-equips>
        <modal class="alarm-orange" :display="modalStatus.editHouse" @modalStatus="closeModal('editHouse')" >
            <img class="alarm-img" src="@/assets/img/icon/alarm_msg_orange.svg" alt="">
            <h1>無法上架</h1>
            <div class="content">
                目前有進行中的合約，請先更新最快起租日
            </div>
            <div class="btn-group">
                <button class="default-button" @click="closeModal('editHouse')">編輯房源</button>
            </div>
        </modal>
        <modal class="delete-house" :display="modalStatus.deleteHouse" @modalStatus="modalStatus.deleteHouse = false" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除房源</h1>
            <div class="content">
                確定刪除“{{editHouse.name}}”的房源嗎？<br>記錄刪除將無法回復
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deleteHouse(), $analytics.logEvent('刪除房源', { screen_name: '刪除房源'})">確認</button>
                <button class="border-button" @click="modalStatus.deleteHouse = false">取消</button>
            </div>
        </modal>
        <share-social-media :cid="$route.query.cid"></share-social-media>
        <div class="tool-bar-mask"></div>
        <div class="edit-add-house-head">
            <h1 class="page-title">{{editHouse.name}}</h1>
            <div class="btn-group" :class="{rented: tenant.name}">
                <div class="item-state" v-if="complete">
                    狀態：已完善
                </div>
                <div class="item-state" v-else>
                    狀態：未完善
                </div>
                <button class="border-button save"  :disabled="houseStatus==2 || taskStatus == 2" v-if="publish" @click="setPublish('HIDE')">下架</button>
                <button class="default-button save" :disabled="houseStatus==2"  v-else-if="tenant.name" @click="saveEditHouseNoReview()">僅儲存</button>
                <button class="border-button save"  :disabled="houseStatus==2" v-else @click="saveEditHouseNoReview()">僅儲存</button>
                <button class="default-button publish" :disabled="houseStatus==2" v-if="publish" @click="saveEditHouse()">儲存設定</button>
                <button class="default-button publish" :disabled="houseStatus==2" v-else @click="saveEditHouse()">儲存並上架</button>
                
                <dot-large-drop-menu>
                    <ul >
                        <!-- <li>新增電子合約</li>-->
                        <router-link v-if="houseStatus!=2 && taskStatus != 2 && taskStatus != 1 && complete" :to="{ name: 'NewTask', query: { hid: editHouse.houseCid }}">
                            <li>新增委託</li>
                        </router-link>
                        <!--<li>歷代租約</li>
                        <li>歷代評價</li>
                        <li>新增記帳</li> -->
                        <li v-if="publish || houseStatus==2" @click="shareSocialMedia(), $analytics.logEvent('分享房源', { screen_name: '分享房源'})">分享房源</li>
                        <li v-if="houseStatus==1  && taskStatus != 2 && taskStatus != 1" @click="modalStatus.deleteHouse = true">刪除房源</li>
                        <!-- <li>預覽畫面</li> -->

                    </ul>
                </dot-large-drop-menu>
            </div>
        </div>
        <div class="user-info">
                <span class="title">租客</span>
                <span v-if="tenant.name" class="name level1-title-font">
                    <img src="../../../../../assets/img/icon/user_shot_black.svg" alt="">
                    租客：{{tenant.name}}
                </span>
                <span v-else class="name level1-title-font">
                    <img src="../../../../../assets/img/icon/user_shot_black.svg" alt="">
                    尚未有租客
                </span>
            </div>
        <div class="edit-add-house-description">
            <h1 class="unit-title">
                房源說明
                <span class="title-description">限上傳 10 張，僅接受 jpg.png，每張不得超過 5ＭＢ</span>
            </h1>
            <div class="house-name">
                <label class="edit-label" for="">廣告標題</label>
                <div class="input-error-group">
                    <input :class="{error: error.nameErr}" type="text" v-model="editHouse.name" placeholder="6-20 個字">
                    <span v-show="error.nameErr" class="error">{{error.nameErr}}</span>
                </div>
            </div>
            <div class="house-rent">
                
                <label class="edit-label" for="">房屋租金</label>
                <div class="input-error-group">
                    <input :class="{error: error.rentMonthlyErr}" type="text" v-model="editHouse.rentMonthly" placeholder="請輸入金額">
                    <span v-show="error.rentMonthlyErr" class="error">{{error.rentMonthlyErr}}</span>
                </div>
            </div>
            <div class="house-intro">
                <label class="edit-label" for="">房源介紹</label>
                <div class="intro-container">
                    <pre class="pre"></pre>
                    <textarea id="edit-description" @keyup="autoGrow()"  :class="{error: error.desErr}" v-model="editHouse.description" placeholder="50-2000 個字" ></textarea>
                    <span class="des-count"><span class="count">{{editHouse.description.length}}</span>/2000</span>
                </div>
                <span v-show="error.desErr" class="error">{{error.desErr}}</span>
            </div>
            <edit-img :imgError="error.imgErr" :imgCoverError="error.imgCoverErr" :imgChangeCoverError="error.imgCoverNotChangeErr"></edit-img>
        </div>
        <div class="edit-add-house-description">
            <h1 class="unit-title">
                上傳影片
                <span class="title-description">
                    <img src="@/assets/img/icon/info_gray.svg" alt="">
                    上傳案件影片讓房客找房更方便，增加成交機率，影片時間建議不要超過兩分鐘
                </span>
            </h1>
            <upload-video @setVideoInfo="setVideoInfo" :isEdit="true" :normalFilm="houseDefault.normalFilm" :lastFilm="houseDefault.lastFilm"></upload-video> 
        </div>
        <div class="edit-add-house-type">
            <h1 class="unit-title">房源類型</h1>
            <div class="section-one">
                <div class="lease-type">
                    <label class="edit-label" for="">出租類型</label>
                    <rent-select :class="{error: error.houseTypeErr}" refName="houseType" :selectMsg="editHouse.houseType?houseType[editHouse.houseType-1].itemName:'請選擇出租類型'" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li v-for="(house, index) in houseType" :key="index" :data-id="house.houseTypeCode">
                                {{house.itemName}}
                            </li>
                        </ul>
                    </rent-select>
                    <span v-show="error.houseTypeErr" class="error">{{error.houseTypeErr}}</span>
                </div>
                <div v-if="editHouse.houseType == 1" class="house-pattern">
                    <label class="edit-label" for="">房源格局</label>
                    <div class="house-pattern-wrap">
                        <rent-select :key="'a'+componentKey" refName="bedroom" :selectMsg="bedroom" @getId="getSelectId" defaultValue="1"  bgColor="#fff" :setDefault="housePattern">
                            <ul>
                                <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                    {{n-1}} 房
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select :key="'b'+componentKey" refName="sharedRoom" :selectMsg="sharedRoom" @getId="getSelectId"  bgColor="#fff" :setDefault="housePattern">
                            <ul>
                                <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                    {{n-1}} 廳
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select :key="'c'+componentKey" refName="bathroom" :selectMsg="bathroom" @getId="getSelectId"  bgColor="#fff" :setDefault="housePattern">
                            <ul>
                                <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                    {{n-1}} 衛浴
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select :key="'e'+componentKey" refName="balcony" :selectMsg="balcony" @getId="getSelectId"  bgColor="#fff" :setDefault="housePattern">
                            <ul>
                                <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                    {{n-1}} 陽台
                                </li>
                            </ul>
                        </rent-select>
                    </div>
                </div>
                
                <div v-else class="house-pattern">
                    <label class="edit-label" for="">房源格局</label>
                    <div class="house-pattern-wrap2">
                        <rent-select :key="'f'+componentKey" refName="hasBalcony" :selectMsg="hasBalcony" @getId="getSelectId"  bgColor="#fff" :setDefault="roomPattern">
                            <ul>
                                <li data-id="1">
                                    有陽台
                                </li>
                                <li data-id="0">
                                    無陽台
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select :key="'g'+componentKey" refName="hasDuplex" :selectMsg="hasDuplex" @getId="getSelectId"  bgColor="#fff" :setDefault="roomPattern">
                            <ul>
                                <li data-id="1">
                                    有閣樓
                                </li>
                                <li data-id="0">
                                    無閣樓
                                </li>
                            </ul>
                        </rent-select>
                    </div>
                </div> 
                <div class="house-type">
                    <label class="edit-label" for="">房屋類型</label>
                    <rent-select :class="{error: error.buildingTypeErr}" refName="buildingType" :selectMsg="editHouse.buildingType?buildingType[editHouse.buildingType-1].itemName:'請選擇房屋類型'" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li v-for="(build, index) in buildingType" :key="index" :data-id="build.buildingTypeCode">
                                {{build.itemName}}
                            </li>
                        </ul>
                    </rent-select>
                    <span v-show="error.buildingTypeErr" class="error">{{error.buildingTypeErr}}</span>
                </div>
                <div class="house-size">
                    <label class="edit-label" for="">房源坪數</label>
                    <div class="input-error-group">
                        <input :class="{error: error.sizeErr}" type="number" v-model="editHouse.size" placeholder="輸入房源坪數">
                        <span v-show="error.sizeErr" class="error">{{error.sizeErr}}</span>
                    </div>
                </div>

                <div class="house-special">
                    <label class="edit-label" for="">特殊樓層</label>
                    <div class="house-floor-wrap">
                        <rent-select :class="{error: error.specialTypeErr}" refName="specialType" :selectMsg="getSpecialType(editHouse.specialType)" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                        <!-- <rent-select refName="specialType" selectMsg="無" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault"> -->
                            <ul>
                                <li v-for="(special, index) in specialType" :key="index" :data-id="special.specialTypeCode">
                                    {{special.itemName}}
                                </li>
                            </ul>
                        </rent-select>
                        <span v-show="error.specialTypeErr" class="error">{{error.specialTypeErr}}</span>
                    </div>
                </div>
                <div class="house-total-floor">
                    <label class="edit-label" for="">房源總樓層</label>
                    <div class="input-error-group">
                        <input :class="{error: error.totalFloorErr}" type="text" v-model="editHouse.totalFloor" placeholder="輸入總樓層">
                        <span v-show="error.totalFloorErr" class="error">{{error.totalFloorErr}}</span>
                    </div>
                </div>
                <div class="shortest-period">
                    <label class="edit-label" for="">繳款方式</label>
                    <rent-select :class="{error: error.payByRentPayDayErr}" refName="payway" :selectMsg="getPayWayWord(editHouse.payByRentPayDay)" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li data-id="contract">
                                {{getPayWayWord('contract')}}
                            </li>
                            <li data-id="date">
                                {{getPayWayWord('date')}}
                            </li>
                        </ul>
                    </rent-select>
                    <span v-show="error.payByRentPayDayErr" class="error">{{error.payByRentPayDayErr}}</span>
                    <span v-if="editHouse.payByRentPayDay" v-show="error.rentPayDayErr" class="error" style="position: absolute;right: -140px;top: 2px;">{{error.rentPayDayErr}}</span>
                    <rent-select v-if="editHouse.payByRentPayDay" class="select-date select-scroll" :class="{error: error.rentPayDayErr}" refName="date" :selectMsg="getRentPayDayWord(editHouse.rentPayDay)" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li v-for="n in 29" :key="n" :data-id="n">
                                每月 {{n}} 號
                            </li>
                            <li :data-id="-1">
                                每月最後一天
                            </li>
                        </ul>
                    </rent-select>
                </div>
                <div class="is-with-landlord">
                    <label class="edit-label" for="">與屋主同住</label>
                    <rent-select :class="{error: error.isWithLandlordErr}" refName="isWithLandlord" :selectMsg="setIsWithLandLord()" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li data-id="1">
                                是
                            </li>
                            <li data-id="0">
                                否
                            </li>
                        </ul>
                    </rent-select>
                    <span v-show="error.isWithLandlordErr" class="error">{{error.isWithLandlordErr}}</span>
                </div>
            </div>
            <div class="section-two">
                <div class="house-address">
                    <label class="edit-label" for="">房源地址</label>
                    <div class="hide-num">
                        <rent-checkbox v-model="editHouse.isNumberHidden" val="1" checkboxMsg="隱藏門牌" tickColor="black" bgColor="#fff" borderColor="#cacfcd" :isPropChecked="editHouse.isNumberHidden" ></rent-checkbox>
                    </div>
                    <span v-show="error.floorErr" class="error">{{error.floorErr}}</span>
                    <span v-show="error.roadStreetCidErr" class="error">{{error.roadStreetCidErr}}</span>
                    <span v-show="error.districtCidErr" class="error">{{error.districtCidErr}}</span>
                    <span v-show="error.cityCidErr" class="error">{{error.cityCidErr}}</span>
                    <div class="house-address-wrap">
                        <rent-select :class="{error: error.cityCidErr}" class="select-scroll" ref="county" refName="county" :selectMsg="address.county.msg" @getId="getSelectId"  bgColor="#fff" :setDefault="address.county.state">
                            <ul>
                                <li v-for="(county, index) in counties" :key="index" :data-id="index" :data-name="county">
                                    {{county}}
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select :key="'district'+componentKey" :class="{error: error.districtCidErr}" class="select-scroll" ref="district" refName="district" :selectMsg="address.district.msg" @getId="getSelectId"  bgColor="#fff" :setDefault="address.district.state">
                            <ul>
                                <li v-for="(district, index) in districts" :key="index" :data-id="district.districtCid" :data-name="district.districtName">
                                    {{district.districtName}}
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select :key="'road'+componentKey" :class="{error: error.roadStreetCidErr}" class="select-scroll select-road" refName="road" :selectMsg="address.road.msg" @getId="getSelectId"  bgColor="#fff" :setDefault="address.road.state">
                            <ul>
                                <div class="road-filter">
                                    <img class="search" src="@/assets/img/icon/search_gray.svg" alt="">
                                    <input v-model="selectRoad" placeholder="搜尋路段" type="text">
                                </div>
                                <li v-for="(road, index) in filterRoad" :key="index" :data-id="road.roadStreetCid" :data-name="road.roadStreetName">
                                    {{road.roadStreetName}}
                                </li>
                            </ul>
                        </rent-select>
                        <div class="lane">
                            <input type="text" v-model="editHouse.lane">
                            <span>巷</span>
                        </div>
                        <div class="alley">
                            <input type="text" v-model="editHouse.alley">
                            <span>弄</span>
                        </div>
                        <div class="number">
                            <input :class="{error: error.numErr}" type="text" v-model="editHouse.number">
                            <span>號之</span>
                        </div>
                        <div class="number">
                            <input type="text" v-model="editHouse.dash">
                        </div>
                        <div class="floor">
                            <input :class="{error: error.floorErr}" type="text" v-model="editHouse.floor">
                            <span>樓之</span>
                        </div>
                        <div class="room">
                            <input type="text" v-model="editHouse.room">
                        </div>
                        
                    </div>
                </div>
                <div class="rent-include">
                    <label class="button-font input-label">
                        <div class="title">
                            提供設備
                        </div>
                    </label>
                    <div class="wrap">
                        <div class="house-equips h-align" :class="{'odd': index%2 === 0}" v-for="(equip, index) in houseEquips" :key="'houseEquips'+index">
                            <checkbox v-model="editHouse.equipmentList[index].check" :msg="equip.itemName" :val="equip.equipCode" :isPropChecked="editHouse.equipmentList[index].check"></checkbox>
                            <div class="input-arear">
                                <span class="quantifier">個</span>
                                <input :class="{'error': error.equipment[index]}"  type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="editHouse.equipmentList[index].count" placeholder="請輸入數量">
                            </div>
                        </div>
                        <div class="house-equips new-equips" @click="$store.dispatch('setModalStatus', {state: true, type: 'bizAddEquips'})">
                            新增設備
                        </div>
                        <!-- <house-checkbox v-model="houseEquip" v-for="(equip, index) in houseEquips" :key="'houseEquips'+index"  :val="equip.equipCode" :checkboxMsg="equip.itemName" :isPropChecked="false" ></house-checkbox> -->
                    </div>
                </div>
                <div class="rent-include">
                    <label class="edit-label" for="">租金包含</label>
                    <div class="wrap">
                        <house-checkbox v-model="houseInclude" v-for="(include, index) in houseRentInclude" :key="index"  :val="include.rentCode" :checkboxMsg="include.itemName" :isPropChecked="include.check" ></house-checkbox>
                    </div>
                </div>
                <bill-charge loginType="LANDLORD" @error="setBillChargeError" :includeList="editHouse.rentIncludeList" :editData="billChargeMode" v-model="editHouse.billChargeMode"></bill-charge>
                <!-- <div class="equipment">
                    <label class="edit-label" for="">提供設備</label>
                    <div class="wrap">
                        <house-checkbox v-model="houseEquip" v-for="(equip, index) in houseEquips" :key="index"  :val="equip.equipCode" :checkboxMsg="equip.itemName" :isPropChecked="equip.check" ></house-checkbox>
                    </div>
                </div> -->
                <div class="rules">
                    <label class="edit-label" for="">特色標籤 ( 最多選擇 6 個 )</label>
                    <div class="wrap">
                        <house-checkbox v-model="houseFeature" v-for="(feature, index) in houseFeatures" :key="index"  :val="feature.featureCode" :checkboxMsg="feature.itemName" :isPropChecked="feature.check" ></house-checkbox>
                    </div>
                </div>
                <div class="rules" v-if="rulesInContract.length">
                    <label class="edit-label" for="">使用規範 ( 會寫入合約內 )</label>
                    <div class="wrap">
                        <span v-for="(item, index) in rulesInContract" :key="index">
                            {{item}}{{rulesInContract.length-1 === index?'':'、'}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="edit-add-house-type">
            <h1 class="unit-title">
                起租日設定
            </h1>
            <div class="lease-info" v-if="rentPeriodList.length">
                目前此房源有 {{rentPeriodList.length}} 個租約，分別為：
                <div v-for="(item, index) in rentPeriodList" :key="index">
                    {{getFormatDateTime(item.contractBeginTime)}} - {{getFormatDateTime(item.contractEndTime)}}
                </div>
            </div>
            <div class="section-one">
                <div class="shortest-period">
                    <label class="edit-label" for="">最短租期</label>
                    <rent-select :class="{error: error.shortestPeriodErr}" refName="shortestPeriod" :selectMsg="editHouse.shortestPeriod?transShortestPeriod(editHouse.shortestPeriod):'請選擇最短租期'" :isEdit="editHouse.shortestPeriod?true:false" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li v-for="(date, index) in houseConfig.shortestPeriod" :key="index" :data-id="date.code">
                                {{date.name}}
                            </li>
                        </ul>
                    </rent-select>
                    <span v-show="error.shortestPeriodErr" class="error">{{error.shortestPeriodErr}}</span>
                </div>
                <div class="move-in-date">
                    <label class="edit-label" for="">最快起租日</label>
                    <date-picker v-model="editHouse.moveInDate" :class="{'active': editHouse.moveInDate && !error.moveInDateErr, 'error': error.moveInDateErr}" :placeholder="editHouse.moveInDate?getFormatDate(editHouse.moveInDate):'請選擇日期'" :disabled-date="notBeforeThisday" format="YYYY-MM-DD" valueType="format"></date-picker>
                    <span v-show="error.moveInDateErr" class="error">{{error.moveInDateErr}}</span>
                    <!-- <div class="contract-data-alarm" v-if="houseDefault.contractBeginTime && houseDefault.contractEndTime">
                        上個合約租期：{{houseDefault.contractBeginTime?getFormatDateTime(houseDefault.contractBeginTime):''}} - {{houseDefault.contractEndTime?getFormatDateTime(houseDefault.contractEndTime):''}}
                    </div> -->
                </div>
            </div>
        </div>
        <div class="edit-contract-version">
            <div class="title-group h-align">
                <h1 class="unit-title">
                    合約版本
                </h1>
                <div class="group">
                    <button class="refresh" v-if="status.isShowReloadBtn" @click="status.reloadContractVertion++, status.isShowReloadBtn=false">
                        <img src="@/assets/img/icon/refresh.svg" alt="">
                        更新合約版本
                    </button>
                </div>
            </div>
            <div>
                <choose-contract-version v-model="editHouse.contractVersionId" @edit="status.isShowReloadBtn=true" :reload="status.reloadContractVertion"></choose-contract-version>
            </div>
        </div>
        <!-- <div class="edit-add-house-policy">
            <h1 class="unit-title">自訂合約條款 ( 電子合約內容 )</h1>
            <div class="house-policy">
                <div class="group">
                    <div class="edit" @click="modalStatus.globalPolocy = true, $analytics.logEvent('新增及編輯政策', { screen_name: '新增及編輯政策'})">
                        <img src="../../../../../assets/img/icon/edit_gray.svg" alt="">
                        編輯政策
                    </div>
                    <div class="view-default">
                        <router-link  :to="{ name: 'defaultpolicy'}" target="_blank">
                            <img src="../../../../../assets/img/icon/view_gray.svg" alt="">
                            預設條款
                        </router-link>
                    </div>
                </div>
                <policy-checkbox v-model="housePolicyComputed" v-for="(housePolicy, index) in housePolicies" :key="index" val="1" :policyId="housePolicy.policySettingCid" :checkboxMsg="housePolicy.policySettingContent" :isPropChecked="housePolicy.policyUsed" ></policy-checkbox>
                <modal class="global-policy" :display="modalStatus.globalPolocy" @modalStatus="modalStatus.globalPolocy = false, getEditHouseDefault()" >
                    <h1>編輯政策</h1>
                    <new-policy class="com-setting-div" :type="1" mainTitle="自訂合約條款"></new-policy>
                </modal>
            
            </div>
        </div>  -->
    </div>
</template>
<script>
import RentSelect from '@/components/widge/RentSelect.vue';
import DatePicker from 'vue2-datepicker';
import RentCheckbox from '@/components/widge/RentCheckbox.vue';
import HouseCheckbox from '@/components/widge/HouseCheckbox.vue';
import PolicyCheckbox from '@/components/widge/PolicyCheckbox.vue';
import EditImg from '@/components/landlord/houseStatus/houseManagement/addHouse/EditImg.vue';
import DotLargeDropMenu from '@/components/widge/DotLargeDropMenu.vue';
import NewPolicy from '@/components/widge/NewPolicy.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import shareSocialMedia from '@/components/widge/shareSocialMedia.vue';
import uploadVideo from '@/components/landlord/houseStatus/houseManagement/addHouse/uploadVideo.vue';
import addEquips from '@/components/bussiness/widges/modals/addEquips.vue';
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';
import billCharge from '@/components/bussiness/mgtCategory/houseMgt/addHouse/billCharge.vue';
import chooseContractVersion from '@/components/landlord/houseStatus/houseManagement/addHouse/chooseContractVersion.vue';
import { 
    getHouseDetail
} from "@/apis/company/houseMgt.js"; 
import { 
    apiGetCounty,
    apiGetDistrict,
    apiGetRoad,
    apiGetContractHouse,
    apiGetContractTenant
} from "@/apis/api.js"; 
import { mapGetters } from 'vuex'


// const today = new Date();
// today.setHours(0, 0, 0, 0);

export default {
    data () {
        return {
            componentKey: 1,
            contractCid: null,
            tenant: {
                cid: null,
                name: null,
            },
            editHouse: {
                "houseCid": null,
                "name": null,
                "cityCid": null,
                "districtCid": null,
                "roadStreetCid": null,
                "lane": null,
                "alley": null,
                "floor": null,
                "number": null,
                "dash": null,
                "room": null,
                "size": null,
                "houseType": null,
                "buildingType": null,
                "specialType": null,
                "rentMonthly": null,
                "moveInDate": null,
                "shortestPeriod": null,
                "isNumberHidden": false,
                "totalFloor": null,
                "isWithLandlord": null,
                "description": null,
                "equipmentList": [],
                "rentIncludeList": [],
                "ruleList": [],
                "rentPayDay": null,
                "payByRentPayDay": null,
                "isPublic": null,
                "filmKey": null,
                "billChargeMode": null,
                "contractVersionId": null,
                "housePatternDto": {
                    "bedroom": 0,
                    "sharedRoom": 0,
                    "bathroom": 0,
                    "balcony": 0
                },
                "roomPatternDto": {
                    "hasBalcony": false,
                    "hasDuplex": false
                },
                "editCaseHousePolicyDto": {
                    "policySettingType": 1,
                    "usePolicyDtoList": []
                },
                "editCaseDepositPolicyDto": {
                    "policySettingType": 2,
                    "usePolicyDtoList": []
                }
            },
            isDefault: false,
            address: {
                county: {
                    state: false,
                    msg: '請選擇縣市'
                },
                district: {
                    state: false,
                    msg: '請選擇區域'
                },
                road: {
                    state: false,
                    msg: '請選擇路名'
                }
            },
            housePattern: false,
            roomPattern: false,
            error: {
                totalFloorErr: '',
                rentMonthlyErr: '',
                sizeErr: '',
                nameErr: '',
                desErr: '',
                numErr: '',
                floorErr: '',
                moveInDateErr: '',
                cityCidErr: '',
                districtCidErr: '',
                roadStreetCidErr: '',
                houseTypeErr: '',
                buildingTypeErr: '',
                shortestPeriodErr: '',
                isWithLandlordErr: '',
                imgErr: false,
                imgCoverErr: false,
                imgCoverNotChangeErr: false,
                rentPayDayErr: '',
                payByRentPayDayErr: '',
                equipment: [],
                billCharge: ''
            },
            modalStatus:{
                globalPolocy: false,
                deleteHouse: false,
                editHouse: false,
            },
            selectRoad: null,
            hasTaker: false,
            taskStatus: null,
            featureListCount: 0,
            status: {
                isShowReloadBtn: false,
                reloadContractVertion: 0
            },
        }
    },
    mounted () {
        this.$analytics.logEvent('編輯房源', { screen_name: '編輯房源'})
        this.$store.dispatch('getHouseConfig')
        this.$store.dispatch('setHouseCid',  this.$route.query.cid)
        .then(() => {
            this.$store.dispatch('getEditHouseDefault')
            .then(() => {
                if(this.houseDefault.cityName != undefined){
                    this.getCounty(this.houseDefault.cityName)
                    this.autoGrow()
                }
            }) 
        })
        this.getHouseInfo(this.$route.query.cid)
    },
    watch: {
        houseDefault: {
            handler: function (newValue, oldValue) {
                newValue.dash = newValue.dash?newValue.dash:''
                newValue.alley = newValue.alley?newValue.alley:''
                this.editHouse.houseCid = newValue.houseCid
                this.editHouse.name = newValue.name
                this.editHouse.lane = newValue.lane
                this.editHouse.alley = newValue.alley
                this.editHouse.dash = newValue.dash
                this.editHouse.payByRentPayDay = newValue.payByRentPayDay
                this.editHouse.rentPayDay = newValue.rentPayDay
                this.editHouse.contractVersionId = newValue.contractVersionId

                if(newValue.floor != undefined && newValue.floor != 0){
                    this.editHouse.floor = newValue.floor
                }else{
                    this.editHouse.floor = ''
                }
                this.editHouse.number = newValue.number
                this.editHouse.room = newValue.room
                if(newValue.size != undefined && newValue.size != 0){
                    this.editHouse.size = newValue.size
                }else{
                    this.editHouse.size = ''
                }
                if(newValue.houseType != undefined && newValue.houseType != 0  && newValue.houseType < 4){
                    this.editHouse.houseType = newValue.houseType
                }
                if(newValue.buildingType != undefined && newValue.buildingType != 0 && newValue.buildingType < 5){
                    this.editHouse.buildingType = newValue.buildingType
                }
                if(newValue.specialType != undefined ){
                    this.editHouse.specialType = newValue.specialType
                }
                if(newValue.rentMonthly != undefined && newValue.rentMonthly != 0){
                    this.editHouse.rentMonthly = newValue.rentMonthly
                }else{
                    this.editHouse.rentMonthly = ''
                }
                if(newValue.moveInDate != undefined && newValue.moveInDate != null){
                    this.editHouse.moveInDate = newValue.moveInDate
                }
                if(newValue.shortestPeriod != undefined && newValue.shortestPeriod != 0){
                    this.editHouse.shortestPeriod = newValue.shortestPeriod
                }
                if(newValue.isNumberHidden != undefined){
                    this.editHouse.isNumberHidden = newValue.isNumberHidden
                }
                if(newValue.totalFloor != undefined && newValue.totalFloor != 0){
                    this.editHouse.totalFloor = newValue.totalFloor
                }else{
                    this.editHouse.totalFloor = ''
                }
                if(newValue.isWithLandlord != undefined){
                    this.editHouse.isWithLandlord = newValue.isWithLandlord
                }
                if(newValue.description != undefined){
                    this.editHouse.description = newValue.description
                }
                
                if( newValue.housePatternDto != undefined ){
                    this.editHouse.housePatternDto.bedroom = newValue.housePatternDto.bedroom
                    this.editHouse.housePatternDto.bathroom = newValue.housePatternDto.bathroom
                    this.editHouse.housePatternDto.balcony = newValue.housePatternDto.balcony
                    this.editHouse.housePatternDto.sharedRoom = newValue.housePatternDto.sharedRoom
                }
                if( newValue.roomPatternDto != undefined){
                    this.editHouse.roomPatternDto.hasBalcony = newValue.roomPatternDto.hasBalcony
                    this.editHouse.roomPatternDto.hasDuplex = newValue.roomPatternDto.hasDuplex
                }
                
                // this.counties.map( (county, index) => {
                //     if(county == newValue.cityName){
                //         this.editHouse.cityCid = index+1
                //         this.address.county.msg = newValue.cityName
                //         this.$store.dispatch('getDistrict', index+1)
                //     }
                // })
                // this.districts.map( (district, index) => {
                //     if(district.districtName == newValue.districtName){
                //         this.editHouse.districtCid = district.districtCid
                //         this.address.district.msg = newValue.districtName
                //         this.$store.dispatch('getRoad', district.districtCid)
                //         this.address.district.state = true
                //     }
                // })
                // // setTimeout(() => {
                //     this.roads.map( (road, index) => {
                //         if(road.roadStreetName == newValue.roadStreetName){
                //             console.log(newValue.roadStreetName)
                //             this.editHouse.roadStreetCid = road.roadStreetCid
                //             this.address.road.msg = newValue.roadStreetName
                //             this.address.road.state = true
                //         }
                //     })
                // // }, 500)
            },
            deep: true,
            immediate: true
        },
        editHouse: {
            handler: function (newValue, oldValue){
                let numerical = /^[0-9]*$/,
                    decimalNum = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/
                
                // console.log(newValue.description)
                // console.log(newValue.description.length)
                if(newValue.name){
                    if(newValue.name.length < 6 ){
                        this.error.nameErr = '廣告標題需滿6個字'
                    }else if(newValue.name.length > 20){
                        this.error.nameErr = '廣告標題20字以內'
                    }else{
                        this.error.nameErr = ''
                    }
                }
                if(newValue.totalFloor){
                    // 總樓層
                    if( numerical.test(newValue.totalFloor) ){
                        this.error.totalFloorErr = ''
                    }else{
                        this.error.totalFloorErr = '請輸入數字'
                    }
                }
                if(newValue.rentMonthly){
                    // 房租
                    if( numerical.test(newValue.rentMonthly) ){
                        this.error.rentMonthlyErr = ''
                    }else{
                        this.error.rentMonthlyErr = '請輸入數字'
                    }
                }
                if(newValue.size){
                    var decimal = /^[0-9]+(\.[0-9]?)?$/;
                    if(decimal.test(newValue.size)){
                        this.error.sizeErr = ''
                    }else{
                        this.error.sizeErr = '請輸入小數1位內'
                    }
                }
                if(newValue.description.length > 2000){
                    this.error.desErr = '字數限制2000以內'
                }else if(newValue.description){
                    this.autoGrow()
                    this.error.desErr = ''
                } 
                if(newValue.houseType){
                    this.error.houseTypeErr = ''
                }
                if(newValue.buildingType){
                    this.error.buildingTypeErr = ''
                }
                if(newValue.specialType != null){
                    this.error.specialTypeErr = ''
                }
                if(newValue.shortestPeriod){
                    this.error.shortestPeriodErr = ''
                }
                if(newValue.cityCid){
                    this.error.cityCidErr = ''
                }
                if(newValue.districtCid){
                    this.error.districtCidErr = ''
                }
                if(newValue.roadStreetCid){
                    this.error.roadStreetCidErr = ''
                }
                if(newValue.number){
                    this.error.numErr = ''
                }
                if(newValue.floor){
                    this.error.floorErr = ''
                }
                if(newValue.moveInDate){
                    this.checkMoveInDate(newValue.moveInDate)
                }
                if(newValue.isWithLandlord != null){
                    this.error.isWithLandlordErr = ''
                }
                if(newValue.payByRentPayDay != null){
                    this.error.payByRentPayDayErr = ''
                }
                if(newValue.payByRentPayDay === false || newValue.rentPayDay){
                    this.error.rentPayDayErr = ''
                }
                if(newValue.equipmentList.length){
                    newValue.equipmentList.forEach(item=>{
                        if(item.check){
                            if(item.count === null){
                                item.count = 1
                            }
                        }else{
                            item.count = null
                        }
                    })
                }
                this.$store.dispatch('setEditHouseList',this.editHouse)
            },
            deep: true
        },
        houseRentInclude: {
            handler: function (newValue, oldValue) {
                this.editHouse.rentIncludeList = newValue
                this.$store.dispatch('setEditHouseList',this.editHouse)
                for (let i = 0; i < newValue.length; i++) {
                    const element = newValue[i];
                    // console.log(element.itemName+element.check)
                    if(element.check){
                        this.removeBillCharge(element.itemName)
                    }
                }
            },
            deep: true
        },
        houseEquips: {
            handler: function (newValue, oldValue) {
                this.editHouse.equipmentList = newValue
                this.$store.dispatch('setEditHouseList',this.editHouse)

            },
            deep: true
        },
        houseFeatures: {
            handler: function (newValue, oldValue) {
                this.editHouse.featureList = newValue
                this.$store.dispatch('setEditHouseList',this.editHouse)
            },
            deep: true
        },
        hasImage: function () {},
        hasCover: function () {},
        hasDefaultCover: function () {},
    },
    methods: {
        setBillChargeError: function (value){
            this.error.billCharge = value
        },
        setNewEquips: function (value) {
            this.editHouse.equipmentList.push({
                check: true,
                itemName: value.name,
                count: value.count?value.count:0
            })
        },
        transShortestPeriod: function (val) {
            let shortestPeriod = this.houseConfig.shortestPeriod

            for (let i = 0; i < shortestPeriod.length; i++) {
                const element = shortestPeriod[i];
                if(element.code == val){
                    return element.name
                }
                
            }
        },
        checkMoveInDate: function (date) {
            let today = new Date();
            today.setHours(0, 0, 0, 0);
            let shortestDay = parseInt(this.editHouse.shortestPeriod)
            let startDate = new Date(new Date(date).getTime() -28800000)
            let endDate = new Date(new Date(date).getTime() -28800000)
            endDate = endDate.setMonth(endDate.getMonth() + shortestDay)
            if(shortestDay){
                this.error.moveInDateErr = ''
                for (let i = 0; i < this.rentPeriodList.length; i++) {
                    const element = this.rentPeriodList[i];
                    // console.log('today:'+today)
                    // console.log('startDate:'+startDate)
                    // console.log('contractBeginTime:'+element.contractBeginTime)
                    // console.log('contractEndTime:'+element.contractEndTime)
                    // console.log('endDate:'+endDate)
                    // console.log('element.contractBeginTime <= endDate:'+element.contractBeginTime <= endDate)
                    // console.log('endDate <= element.contractEndTime:'+endDate <= element.contractEndTime)
                    if(startDate < today){
                        this.error.moveInDateErr = '最快起租日不能早於今日'
                        return
                    }else if(element.contractBeginTime <= endDate && endDate <= element.contractEndTime || element.contractBeginTime <= startDate && startDate <= element.contractEndTime || element.contractBeginTime >= startDate && endDate >= element.contractEndTime){
                        this.error.moveInDateErr = '最快起租日與租約衝突，請調整起租日或最短租期'
                        return
                    }else{
                        this.error.moveInDateErr = ''
                    }
                }
            }
            // console.log('currentDay', currentDay)
            // console.log('dateDiff', dateDiff)
        },
        setVideoInfo: function(val){
            if(!val) return
            this.editHouse.isPublic = val.isPublic
            this.editHouse.filmKey = val.filmId
        },
        getSelectId: function (value) {
            let targetId = parseInt(event.target.dataset.id)
            if( value.ref == 'houseType' ){
                this.componentKey += 1
                this.roomPattern = true
                this.housePattern = true
                this.editHouse.houseType = targetId
            }else if( value.ref == 'buildingType'){
                this.editHouse.buildingType = targetId
            }else if ( value.ref == 'specialType' ){
                this.editHouse.specialType = targetId
            }else if( value.ref == 'shortestPeriod' ){
                this.editHouse.shortestPeriod = targetId
            }else if( value.ref == 'bedroom' ){
                this.roomPattern = false
                this.housePattern = false
                this.editHouse.housePatternDto.bedroom = targetId
            }else if( value.ref == 'bathroom' ){
                this.roomPattern = false
                this.housePattern = false
                this.editHouse.housePatternDto.bathroom = targetId
            }else if( value.ref == 'sharedRoom' ){
                this.roomPattern = false
                this.housePattern = false
                this.editHouse.housePatternDto.sharedRoom = targetId
            }else if( value.ref == 'balcony' ){
                this.roomPattern = false
                this.housePattern = false
                this.editHouse.housePatternDto.balcony = targetId
            }else if( value.ref == 'hasBalcony' ){
                this.roomPattern = false
                this.housePattern = false
                if( event.target.dataset.id == 1){
                    this.editHouse.roomPatternDto.hasBalcony = true
                }else{
                    this.editHouse.roomPatternDto.hasBalcony = false
                }
            }else if( value.ref == 'hasDuplex' ){
                this.roomPattern = false
                this.housePattern = false
                if( targetId == 1){
                    this.editHouse.roomPatternDto.hasDuplex = true
                }else{
                    this.editHouse.roomPatternDto.hasDuplex = false
                }
            }else if( value.ref == 'isWithLandlord' ){
                if( event.target.dataset.id == 1){
                    this.editHouse.isWithLandlord = true
                }else{
                    this.editHouse.isWithLandlord = false
                }
            }else if ( value.ref == 'county' ){
                this.address.district.state = false

                this.editHouse.cityCid = targetId+1
                this.address.county.msg = event.target.dataset.name
                this.address.district.msg = '請選擇區域'
                this.address.road.msg  = '請選擇路段'
                this.address.road.state = true
                this.address.district.state = true
                this.editHouse.districtCid = null
                this.editHouse.roadStreetCid = null
                

                this.$store.dispatch('getDistrict',(targetId+1))
            }else if ( value.ref == 'district' ){
                this.editHouse.districtCid = targetId
                this.address.district.msg = event.target.dataset.name
                this.address.road.msg  = '請選擇路段'
                this.address.road.state = true
                this.address.district.state = false
                this.editHouse.roadStreetCid = null
                this.$store.dispatch('getRoad',(targetId))
            }else if ( value.ref == 'road' ){
                this.editHouse.roadStreetCid = targetId
                this.address.road.msg = event.target.dataset.name
                this.address.road.state = false
            }else if( value.ref == 'payway'){
                if(event.target.dataset.id === 'date'){
                    this.editHouse.payByRentPayDay = true
                }else if(event.target.dataset.id === 'contract'){
                    this.editHouse.payByRentPayDay = false
                }
            }else if( value.ref == 'date'){
                this.editHouse.rentPayDay = targetId
            }
        },
        setIsWithLandLord: function () {
            let isWithLanLord = this.editHouse.isWithLandlord
            if( isWithLanLord == null){
                return '請選擇屋主是否同住'
            }else if(isWithLanLord == true){
                return '是'
            }else if(isWithLanLord == false){
                return '否'
            }else{
                return '請選擇屋主是否同住'
            }
        },
        getHouseInfo: function (hid) {
            const data = {
                houseCid: hid,
                isLandlordWeb: true
            }
            getHouseDetail(data)
            .then( res => {
                console.log(res)
                if(res.data.status = 'SUCCESS'){
                    this.contractCid = res.data.result.houseDetail.contractCid
                    this.hasTaker = res.data.result.houseDetail.taskTaker
                    this.taskStatus = res.data.result.houseDetail.taskStatus
                    if(this.contractCid){
                        this.getContractDetail()
                        this.getContractTenant()
                    }
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        getContractTenant: function () {
            let data = this.contractCid
            apiGetContractTenant(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.tenant.cid = res.data.result.tenantCid
                    this.tenant.name = res.data.result.tenantName
                }else{
                    this.alart.fail = true
                    this.msg.error = res.data.errorMsg
                    this.errorCode = res.data.errorCode
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getContractDetail: function (){
            let data = this.contractCid
            apiGetContractHouse(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // this.contractDetail.isPaperContract = res.data.result.isPaperContract
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        saveEditHouse: function () {
            this.$analytics.logEvent('儲存並上架', { screen_name: '儲存並上架'})
            if(this.checkInput()){
                if(this.houseStatus === 3 && this.houseDefault.contractEndTime > new Date(this.editHouse.moveInDate).getTime()){
                    this.modalStatus.editHouse = true
                    return false
                }
                // this.editHouse.alley = this.editHouse.alley?this.editHouse.alley:0
                this.editHouse.editCaseHousePolicyDto.usePolicyDtoList = this.housePolicies
                this.editHouse.editCaseDepositPolicyDto.usePolicyDtoList = this.despositPolicies
                // console.log(this.editHouse)
                this.$store.dispatch('setSaveType', 'REVIEW')
                this.$store.dispatch('setLoadingState', 1)
                this.$store.dispatch('saveEditHouse', this.editHouse)
                .then(() =>{
                    if(this.$route.query.type === 'contract'){
                        this.$router.push({ name: 'newcontract'})
                    }else{
                        this.$router.push({ name: 'HouseManagementDefault'})
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '編輯房源成功',type: 'success'})
                    }
                    // this.$store.dispatch('setLoadingState', 0)
                })
            }

        },
        saveEditHouseNoReview: function () {
                this.$analytics.logEvent('僅儲存', { screen_name: '僅儲存'})
                this.editHouse.editCaseHousePolicyDto.usePolicyDtoList = this.housePolicies
                this.editHouse.editCaseDepositPolicyDto.usePolicyDtoList = this.despositPolicies
                if(this.complete ){
                    if(this.checkInput('NO_REVIEW')){
                        // console.log(this.editHouse)
                        this.$store.dispatch('setSaveType', 'NO_REVIEW')
                        this.$store.dispatch('setLoadingState', 1)
                        this.$store.dispatch('saveEditHouseNoReview', this.editHouse)
                        .then(() =>{
                            if(this.$route.query.type === 'contract'){
                                this.$router.push({ name: 'newcontract'})
                            }else{
                                this.$router.push({ name: 'HouseManagementDefault'})
                                this.$store.dispatch('setAlarmStatus', {status: true,title: '編輯房源成功',type: 'success'})
                            }
                            // this.$store.dispatch('setLoadingState', 0)
                        })
                    }
                }else{
                    if(this.noReviewCheckInput()){
                        this.$store.dispatch('setSaveType', 'NO_REVIEW')
                        this.$store.dispatch('setLoadingState', 1)
                        this.$store.dispatch('saveEditHouseNoReview', this.editHouse)
                        .then(() =>{
                            this.$router.push({ name: 'HouseManagementDefault'})
                            // this.$store.dispatch('setLoadingState', 0)
                        })
                    }
                }
                

        },
        deleteHouse: function () {
            this.$store.dispatch('deleteEditHouse', this.$route.query.cid)
            .then( () => {
                this.$store.dispatch('setApiStatus', 'update')
                this.$router.replace('/landlord/housemgt/home')
            });
        },
        setPublish: function (status) {
            this.$analytics.logEvent("下架");
            this.$store.dispatch('setEditPublish', status)
        },
        notBeforeThisday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            let contractPeriod = this.rentPeriodList
            if(contractPeriod.length){
                for (let i = 0; i < contractPeriod.length; i++) {
                    const period = contractPeriod[i];
                    if(period.contractBeginTime-86400000 < date && period.contractEndTime+28800000 > date || today > date){
                        return true
                    }
                }
            }else{
                return today > date
            }
        },
        autoGrow: function (){
            let textarea = document.getElementById('edit-description')
            let adjustedHeight=textarea.clientHeight;

            adjustedHeight=Math.max(textarea.scrollHeight,adjustedHeight);
            // if (adjustedHeight>textarea.clientHeight){
                textarea.style.height=adjustedHeight+'px';
            // }

        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        noReviewCheckInput (){
            if(!this.editHouse.name){
                this.error.nameErr = '房源名稱需滿6個字'
            }
            // if(this.editHouse.billChargeMode.length){
            //     for (let i = 0; i < this.editHouse.billChargeMode.length; i++) {
            //         const element = this.editHouse.billChargeMode[i];
            //         if(element.type !=='PAY_BY_SELF' && !element.amount && !this.isInRentInclude(element.itemName)){
            //             this.$store.dispatch('setAlarmStatus', {status: true,title: `${element.itemName}不得為空值`,type: 'error'})
            //             this.error.billCharge = true
            //             return
            //         }
            //     }
            // }
            if(
                this.editHouse.name.length > 5 &&
                this.editHouse.name.length < 21 &&
                this.error.nameErr == '' 
                // !this.error.billCharge
            ){
                return true
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '請確認所有必填欄位都已填寫完畢',type: 'error'})
                return false
            }
        },
        checkInput: function (type) {
            if(type !== 'NO_REVIEW'){
                this.checkMoveInDate(this.editHouse.moveInDate)
                if(this.notBeforeThisday()){
                    if(this.houseStatus == 3){
                        this.error.moveInDateErr = '最快入住日期需晚於合約迄日'
                    }else{
                        this.error.moveInDateErr = '最快入住日期需晚今日'
                    }
                }
            }else{
                this.error.moveInDateErr = ''
            }
            if(!this.hasImage){
                this.error.imgErr = true
            }else{
                this.error.imgErr = false
            }
            if(!this.hasCover){
                this.error.imgCoverErr = true
            }else{
                this.error.imgCoverErr = false
            }
            if(!this.hasDefaultCover){
                this.error.imgCoverNotChangeErr = true
            }else{
                this.error.imgCoverNotChangeErr = false
            }
            
            if(!this.editHouse.name){
                this.error.nameErr = '房源名稱需滿6個字'
            }
            if(!this.editHouse.rentMonthly){
                this.error.rentMonthlyErr = '請填寫租金'
            }

            if(!this.editHouse.description){
                this.error.desErr = '請填寫房源描述'
            }

            if(!this.editHouse.size){
                this.error.sizeErr = '請填寫坪數'
            }

            if(!this.editHouse.totalFloor){
                this.error.totalFloorErr = '請填寫總樓層'
            }

            if(!this.editHouse.number){
                this.error.numErr = '請填寫完整欄位'
            }

            if(!this.editHouse.floor){
                this.error.floorErr = '請填寫完整欄位'
            }

            if(!this.editHouse.moveInDate){
                this.error.moveInDateErr = '請填寫起租日'
            }
            
            if(!this.editHouse.cityCid){
                this.error.cityCidErr = '請填寫完整欄位'
            }
            if(!this.editHouse.districtCid){
                this.error.districtCidErr = '請填寫完整欄位'
            }
            if(!this.editHouse.roadStreetCid){
                this.error.roadStreetCidErr = '請填寫完整欄位'
            }
            if(!this.editHouse.houseType){
                this.error.houseTypeErr = '請選擇出租類型'
            }
            if(!this.editHouse.buildingType){
                this.error.buildingTypeErr = '請選擇房屋類型'
            }
            if(this.editHouse.specialType == null){
                this.error.specialTypeErr = '請選擇特殊樓層'
            }
            if(!this.editHouse.shortestPeriod){
                this.error.shortestPeriodErr = '請選擇最短租期'
            }
            if(this.editHouse.isWithLandlord == null){
                this.error.isWithLandlordErr = '請選擇屋主是否同住'
            }
            if(this.editHouse.payByRentPayDay == null){
                this.error.payByRentPayDayErr = '請選擇繳款方式'
            }
            if(this.editHouse.payByRentPayDay && this.editHouse.rentPayDay == null){
                this.error.rentPayDayErr = '請選擇繳款日'
            }
            
            if(this.checkEquip.isError){
                this.$store.dispatch('setAlarmStatus', {status: true,title: `提供設備：${this.checkEquip.itemName}不得為空值`,type: 'error'})
                return
            }
            if(this.editHouse.billChargeMode.length){
                for (let i = 0; i < this.editHouse.billChargeMode.length; i++) {
                    const element = this.editHouse.billChargeMode[i];
                    if(element.type !=='PAY_BY_SELF' && !element.amount && !this.isInRentInclude(element.itemName)){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: `${element.itemName}不得為空值`,type: 'error'})
                        this.error.billCharge = true
                        return
                    }
                }
            }
            if(
                this.editHouse.name &&
                this.editHouse.rentMonthly &&
                this.editHouse.description &&
                this.editHouse.totalFloor &&
                this.editHouse.number &&
                this.editHouse.floor &&
                this.editHouse.moveInDate &&
                this.editHouse.districtCid &&
                this.editHouse.roadStreetCid &&
                this.editHouse.houseType &&
                this.editHouse.buildingType &&
                this.editHouse.cityCid &&
                this.editHouse.isWithLandlord != null &&
                this.editHouse.specialType != null &&
                this.editHouse.shortestPeriod &&
                !this.checkEquip.isError &&
                this.hasImage &&
                this.hasCover &&
                this.hasDefaultCover &&
                !this.error.billCharge &&
                this.error.totalFloorErr == '' &&
                this.error.rentMonthlyErr == '' &&
                this.error.sizeErr == '' &&
                this.error.nameErr == '' &&
                this.error.desErr == '' &&
                this.error.floorErr == '' &&
                this.error.moveInDateErr == '' &&
                this.error.cityCidErr == '' &&
                this.error.districtCidErr == '' &&
                this.error.roadStreetCidErr == '' &&
                this.error.houseTypeErr == '' &&
                this.error.buildingTypeErr == '' &&
                this.error.specialTypeErr == '' &&
                this.error.shortestPeriodErr == '' &&
                this.error.isWithLandlordErr == ''
            ){
                return true
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '請確認所有必填欄位都已填寫完畢',type: 'error'})
                return false
            }
        },
        isInRentInclude: function (itemName) {
            for (let i = 0; i < this.houseRentInclude.length; i++) {
                const element = this.houseRentInclude[i];
                if(element.check && element.itemName === itemName){
                    return true
                }
            }
        },
        getEditHouseDefault: function () {
            this.$store.dispatch('getEditHousePolicy', this.$route.query.cid)
        },
        closeAlart: function () {
            this.$store.commit('editHouse/set_save_fail', {status: false, msg: ''})
            this.$store.commit('editHouse/set_save_success', {status: false, msg: ''})
        },
        openModal: function (type) {
            if(type == 'editHouse'){
                this.modalStatus.editHouse = true
            }
        },
        closeModal: function (type) {
            if(type == 'editHouse'){
                this.modalStatus.editHouse = false
            }
        },
        getSpecialType: function (val) {
            if(val == 0){
                return '無'
            }else if(val == 3){
                return '頂樓加蓋'
            }else if(val == 4){
                return '地下室'
            }
        },
        getCounty: function (county) {
            let _self = this
            apiGetCounty()
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.data
             
                    for (let i = 0; i < value.length; i++) {
                        const item = value[i];
                        // console.log(item)
                        if( item == county){
                            // console.log(item)
                            _self.editHouse.cityCid = i+1
                            _self.address.county.msg = item
                            _self.address.county.state = true
                            _self.$store.dispatch('getDistrict', i+1)
                            .then( () => {
                                _self.getDistrict(i+1)
                            })
                            return
                        }else{
                            _self.editHouse.cityCid = null
                        }
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getDistrict: function (data) {
            let _self = this
            apiGetDistrict(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.districtVoList
                 
                    for (let i = 0; i < value.length; i++) {
                        const item = value[i];
                        if( item.districtName == _self.houseDefault.districtName ){
                            _self.editHouse.districtCid = item.districtCid
                            _self.address.district.msg = item.districtName
                            this.componentKey += 1
                            _self.$store.dispatch('getRoad', item.districtCid)
                            .then(()=>{
                                _self.getRoad(item.districtCid)
                            })
                            return
                        }else{
                            _self.editHouse.districtCid = null
                        }
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getRoad: function (data) {
            apiGetRoad(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.roadVoList
                    let roadNameTmp = this.houseDefault.roadStreetName
                    for (let i = 0; i < value.length; i++) {
                        const item = value[i];
                        if( item.roadStreetName == roadNameTmp){
                            this.editHouse.roadStreetCid = item.roadStreetCid;
                            this.address.road.msg = roadNameTmp;
                            this.componentKey += 1
                            return
                        }else{
                            this.editHouse.roadStreetCid = null
                            this.address.road.msg = '請選擇路段'
                        }
                    }
                  
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        shareSocialMedia: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'shareSocialMedia'})
        },
        setFeaturesCount: function () {
            let features = this.editHouse.featureList,
            count = 0
            features.forEach((item)=>{
                if(item.check){
                    count++
                }
            })
            this.featureListCount = count
        },
        removeBillCharge: function (itemName) {
            const list = this.editHouse.billChargeMode
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                if(element.itemName === itemName){
                    this.editHouse.billChargeMode.splice(i, 1)
                }
                
            }
        }
    },
    computed: {
        checkEquip: function () {
            const list = this.editHouse.equipmentList
            let data = {
                itemName: null,
                isError: false
            }
            list.forEach((item, index) =>{
                if(item.check && !item.count){
                        data.isError = true
                        data.itemName = item.itemName
                        this.error.equipment[index] = true
                }else{
                    this.error.equipment[index] = false
                }
                this.componentKey++
            })
            return data
        },
        hasBalcony: function () {
            let balcony = this.houseDefault.roomPatternDto
            if(  balcony != undefined  && balcony.hasBalcony == true ){
                return '有陽台'
            }else{
                return '無陽台'
            }
        },
        hasDuplex: function () {
            let duplex = this.houseDefault.roomPatternDto
            if(  duplex != undefined  && duplex.hasDuplex == true ){
                return '有閣樓'
            }else{
                return '無閣樓'
            }
        },
        balcony: function () {
            let balcony = this.houseDefault.housePatternDto
            // console.log(balcony)
            if(  balcony != undefined ){
                return balcony.balcony + '陽台'
            }else{
                return '陽台'
            }
        },
        bathroom: function () {
            let bathroom = this.houseDefault.housePatternDto
            if(  bathroom != undefined ){
                return bathroom.bathroom + '衛浴'
            }else{
                return '衛浴'
            }
        },
        bedroom: function () {
            let bedroom = this.houseDefault.housePatternDto
            if(  bedroom != undefined ){
                return bedroom.bedroom + '房'
            }else{
                return '房'
            }
        },
        sharedRoom: function () {
            let sharedRoom = this.houseDefault.housePatternDto
            if(  sharedRoom != undefined ){
                return sharedRoom.sharedRoom + '廳'
            }else{
                return '廳'
            }
        },
        houseInclude:{
            get: function () {
                return // ...
            },
            set: function (val) {
                // console.log(val)
                this.houseRentInclude.map( item => {
                    // console.log(val)
                    if( item.itemName == val.name ){
                        if( val.value == true ){
                            item.check = true
                        }else{
                            item.check = false
                        }
                    }
                });
            }
        },
        houseFeature:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.houseFeatures.map( item => {
                    if( item.itemName == val.name ){
                        if(val.value && this.featureListCount >= 6){
                            this.$store.dispatch('setAlarmStatus', {status: true,title: '特色標籤，最多選擇 6 個',type: 'error'})
                        }else{
                            if( val.value == true ){
                                item.check = true
                            }else{
                                item.check = false
                            }
                        }
                    }
                });
                this.setFeaturesCount()
            }
        },
        houseEquip:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.houseEquips.map( item => {
                    if( item.itemName == val.name ){
                        if( val.value == true ){
                            item.check = true
                        }else{
                            item.check = false
                        }
                    }
                });
            }
        },
        rulesInContract: function() {
            let arr = []
            let features = this.editHouse.featureList

            for (let i = 0; i < features.length; i++) {
                const element = features[i];
                if(element.listInContract){
                    // arr[j] = element
                    if(element.listInContractWhen === 'FEATURE_NOT_SELECTED' && !element.check){
                        arr.push(element.listInContractName)
                    }else if(element.listInContractWhen === 'FEATURE_SELECTED' && element.check){
                        arr.push(element.listInContractName)
                    }
                }
            }
            return arr
        },
        housePolicyComputed:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.housePolicies.map( item => {
                    if( item.policySettingCid == val.id ){
                        if( val.value == true ){
                            item.policyUsed = true
                        }else{
                            item.policyUsed = false
                        }
                        
                    }
                });
            }
        },
        despositPolicyComputed:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.despositPolicies.map( item => {
                    if( item.policySettingCid == val.id ){
                        if( val.value == true ){
                            item.policyUsed = true
                        }else{
                            item.policyUsed = false
                        }
                    }
                });
            }
        },
        filterRoad: function () {
            return this.roads.filter((road) => {
                // console.log(road.roadStreetName)
                if( this.selectRoad ){
                    if(road.roadStreetName.includes(this.selectRoad)){
                        return road
                    }
                }else{
                    return road
                }
            });
        },
        ...mapGetters({
            houseFeatures: 'GET_EDIT_FEATURES',
            houseEquips: 'GET_EDIT_EQUIPS',
            houseRentInclude: 'GET_EDIT_RENT_INCLUDE',
            buildingType: 'GET_EDIT_BUILDING_TYPE',
            houseType: 'GET_EDIT_HOUSE_TYPE',
            specialType: 'GET_EDIT_SPECIAL_TYPE',
            counties: 'COUNTY_RESULT',
            districts: 'DISTRICTS_RESULT',
            roads: 'ROAD_RESULT',
            houseDefault: 'GET_EDIT_HOUSE_DEFAULT',
            housePolicies: 'GET_EDIT_HOUSE_POLICY',
            despositPolicies: 'GET_EDIT_DESPOSIT_POLICY',
            complete: 'GET_EDIT_HOUSE_COMPELETE',
            publish: 'GET_EDIT_HOUSE_PUBLISH',
            alartError: 'GET_EDIT_ERROR_STATE',
            alartSuccess: 'GET_EDIT_SUCCESS_STATE',
            hasImage: 'GET_EDIT_HOUSE_HAS_IMAGE',
            hasCover: 'GET_EDIT_HOUSE_HAS_COVER',
            hasDefaultCover: 'GET_EDIT_HOUSE_HAS_CHANGE_COVER',
            houseStatus: 'GET_EDIT_HOUSE_STATUS',
            moveInDateStart: 'GET_EDIT_HOUSE_MOVE_IN_DATE_START',
            rentPeriodList: 'GET_EDIT_RENT_PERIOD_LIST',
            houseConfig: 'GET_HOUSE_CONFIG',
            billChargeMode: 'GET_EDIT_HOUSE_BILL_CHRAGE_MODE',
        })
    },
    components: {
        DatePicker,
        RentSelect,
        RentCheckbox,
        HouseCheckbox,
        EditImg,
        PolicyCheckbox,
        DotLargeDropMenu,
        Modal,
        NewPolicy,
        AlartMsg,
        shareSocialMedia,
        uploadVideo,
        addEquips,
        Checkbox,
        billCharge,
        chooseContractVersion
    }
}
</script>
<style lang="scss">
    .edit-add-house{
        #modal.delete-house{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
        span.error{
            right: 0;
            top: -27px;
            left: unset;
            bottom: unset;
        }
        .edit-add-house-head{
            position: relative;
            margin-top: 22px;
            margin-bottom: 40px;
            .btn-group{
                position: absolute;
                display: flex;
                align-items: center;
                top: -11px;
                right: 17px;
                .item-state{
                    margin-right: 24px;
                }
                .save{
                    width: 104px;
                    margin-right: 16px;
                }
                .publish{
                    width: 104px;
                    margin-right: 16px;
                }
            }
            
        }
        .user-info{
                position: relative;
                display: flex;
                align-items: center;
                height: 72px;
                margin-bottom: 60px;
                border-radius: 10px;
                background-color: rgba(255, 255, 255, 0.5);
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                .title{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 76px;
                    height: 100%;
                    margin-right: 24px;
                    color: #a8a5a4;
                    border-right:1px solid #f1f5f4;
                }
                .name{
                    display: flex;
                    align-items: center;
                    font-weight: 500;
                    margin-right: 18px;
                    img{
                        margin-right: 8px;
                    }
                }
            }
        .unit-title{
            display: flex;
            align-items: center;
            font-size: 20px;
            margin-bottom: 30px;
            color: #ff9275
        }
        .title-description{
            padding-left: 16px;
            color: #a8a5a4;
            font-size: 14px;
        }
        .edit-label{
            display: block;
            font-weight: 500;
            margin-bottom: 12px;
        }
        // input{
        //     margin-bottom: 30px;
        // }
        .rent-select{
            background: #fff;
            span{
                color: #a8a5a4 !important;
            }
        }
        .edit-add-house-description,
        .edit-add-house-type,
        .edit-house-policy,
        .edit-contract-version{
            margin-bottom: 60px;
        }
        .edit-add-house-description{
            width: 1156px;
            >div{
                margin-bottom: 30px;
            }
            input{
                width: 1120px;
            }
            textarea{
                width: 1120px;
                padding: 12px 16px;
            }
            .house-intro{
                position: relative;
                min-height: 100px;
                span.error {
                    right: 0;
                    top: 3px;
                    left: unset;
                    bottom: unset;
                }
                .intro-container{
                    position: relative;
                    min-height: 84px;
                    textarea{
                        position: relative;
                        top: 0px;
                        left: 0px;
                        min-height: 84px;
                        height: 100%;
                        padding: 12px 476px 12px 16px;
                        // background: transparent;
                        outline: 0;
                        resize: none;
                        overflow: hidden;
                    }
                    .des-count{
                        position: absolute;
                        z-index: 2;
                        right: 46px;
                        bottom: 12px;
                        color: #c5c2c1;
                        .count{
                            color: #292625;
                        }
                    }
                    // .pre{
                    //     display: block;
                    //     visibility: hidden;
                    // }
                }
            }
           
        }
        .edit-add-house-type{
            .section-one{
                display: flex;
                flex-wrap: wrap;
                width: 1056px;
                > div{
                    position: relative;
                    width: 424px;
                    margin-bottom: 30px;
                }
                > div:nth-child(odd){
                    margin-right: 208px;
                }
                .shortest-period span.error,
                .is-with-landlord span.error,
                .lease-type span.error,
                .house-special span.error,
                .house-type span.error{
                    right: 0;
                    top: 2px;
                    left: unset;
                    bottom: unset;
                }
                .house-size{
                    input{
                        width: 390px;
                    }
                }
                .house-pattern{
                    .house-pattern-wrap{
                        display: flex;
                        align-items: center;
                        .rent-select{
                            width: 97px;
                            margin-right: 12px;
                        }
                        .rent-select:last-child{
                            margin-right: 0px;
                        }
                        
                    }
                    .house-pattern-wrap2{
                        display: flex;
                        align-items: center;
                        .rent-select{
                            width: 169px;
                        }
                        .rent-select:first-child{
                            margin-right: 12px;
                        }
                    }
                }
                .house-floor{
                    .house-floor-wrap{
                        display: flex;
                        align-items: center;
                        .rent-select{
                            width: 206px;
                            margin-right: 12px;
                        }
                        input{
                            width: 172px;
                            margin-bottom: 0px;
                        }
                    }
                }
                .house-total-floor{
                    input{
                        width: 390px;
                    }
                }
                .select-date{
                    position: absolute;
                    width: 98px;
                    top: 28px;
                    right: -142px;
                }
                .move-in-date{
                    .mx-datepicker{
                        width: 424px;
                        input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #f3f3f3;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                            margin-bottom: 0px;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 14px;
                        }
                    }
                    .mx-datepicker.error{
                        input{
                            border: 1px solid #fc7171 !important;
                        }
                    }
                    .mx-datepicker:hover,
                    .mx-datepicker.active{
                        ::-webkit-input-placeholder { color: #676362; }
                        input::-moz-placeholder{
                            color:#676362;
                        }
                        input{
                            border: 1px solid #676362 !important;
                            color: #676362 !important;
                        }
                        i{
                            color: #676362;
                        }
                    }
                    span.error {
                        right: 0;
                        top: 3px;
                        left: unset;
                        bottom: unset;
                    }
                }
                
            }
            .section-two{
                width: 1148px;
                .house-address{
                    position: relative;
                    margin-bottom: 30px;
                    display: flex;
                    flex-wrap: wrap;
                    span.error {
                        right: 52px;
                        top: 4px;
                        left: unset;
                        bottom: unset;
                    }
                    .hide-num{
                        position: relative;
                        top: -4px;
                        margin-left: 12px;
                    }
                    .house-address-wrap{
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        label{
                            margin-bottom: 0px;
                        }
                        > div{
                            margin-right: 12px;
                            margin-bottom: 16px;
                        }
                        > div:nth-child(-n+2){
                            width: 170px;
                        }
                        > div:nth-child(n+4){
                            color: #525956;
                            input{
                                width: 174px;
                                margin-bottom: 0px;
                            }
                        }
                        .select-road{
                            width: 174px;
                        }
                    }
                }
                .rent-include,
                .equipment,
                .rules{
                    margin-bottom: 30px;
                    .wrap{
                        display: flex;
                        flex-wrap: wrap;
                        > div{
                            margin-right: 12px;
                        }
                    }
                }
                .house-equips{
                    position: relative;
                    width: 424px;
                    margin-bottom: 16px !important;
                    justify-content: space-between;
                    &.odd{
                        margin-right: 208px !important;
                    }
                    &.new-equips{
                        border-radius: 4px;
                        border: solid 1px #e0dfde;
                        background-color: #ffffff;
                        height: 42px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                    }
                    .input-arear{
                        width: 310px;
                        >input{
                            width: 100%;
                            box-sizing: border-box;
                        }
                        .quantifier{
                            position: absolute;
                            right: 16px;
                            top: 12px;
                        }
                    }
                }
            }
        }
        .lease-info{
            width: 1138px;
            border-radius: 4px;
            border: solid 1px #fc7171;
            background-color: #fef0f0;
            color: #fc7171;
            line-height: 1.63;
            padding: 16px 24px;
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 30px;
            box-sizing: border-box;
        }
        .contract-data-alarm{
            margin-top: 6px;
        }
        .edit-add-house-policy{
            .house-policy{
                position: relative;
                margin-bottom: 60px;
                .group{
                    position: absolute;
                    display: flex;
                    top: -53px;
                    right: 22px;
                    >div{
                        a{
                            display: flex;
                            align-items: center;
                            >img{
                                margin-right: 4px;
                            }
                        }
                    }
                    .edit{
                        margin-right: 28px;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        >img{
                            margin-right: 4px;
                        }
                    }
                }
            }
            .global-policy{
                .modal-content{
                    // width: 1198px;
                    // height: 760px;
                    padding: 0 32px !important;
                    .detail{
                        h1{
                            margin: 30px 0;
                        }
                        width: 1198px;
                        // height: 760px;
                        overflow-x: hidden;
                    }
                    // .detail::-webkit-scrollbar {
                    //     display: none;
                    // }
                }
                
            }
        }
    }
    .edit-contract-version{
        .title-group{
            justify-content: space-between;
            .group{
                display: flex;
                align-items: center;
                .refresh{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    border-radius: 4px;
                    background-color: #3942b5;
                    width: 134px;
                    height: 32px;
                    font-size: 14px;
                    color: #fff;
                    right: 29px;
                    cursor: pointer;
                    margin-bottom: 30px;
                    >img{
                        margin-right: 6px;
                    }
                }
            }
        }
    }
    .edit-add-house.fixed{
        .tool-bar-mask{
            position: fixed;
            width: 100%;
            background: #fff;
            height: 80px;
            top: 0px;
            z-index: 7;
            border-bottom: 1px solid #f0f0f0;
            margin-left: -39px;
        }
        .edit-add-house-head{
            position: relative;
            margin-top: 22px;
            margin-bottom: 40px;
            h1{
                position: fixed;
                top: 26px;
            }
            .btn-group{
                position: fixed;
                top: 19px;
                right: unset;
                margin-left: 747px;
                .save{
                    width: 104px;
                    margin-right: 16px;
                }
                .publish{
                    width: 118px;
                }
            }
            .btn-group.rented{
                margin-left: 881px;
            }

            
        }
    }
    @media screen and (max-width: 1280px) {
        .edit-add-house{
            .user-info{
                width: 1142px;
            }
            .edit-add-house-description{
                width: 1142px;
                input,
                textarea
                {
                    width: 1108px;
                }
            }
        }
        .edit-add-house.fixed{
            .edit-add-house-head{
                .btn-group{
                    margin-left: 733px;
                }
                .btn-group.rented{
                    margin-left: 750px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/houseManagement/addHouse/EditHouseComp.vue